import {TabType} from 'router/settings'
import {JobStatusType, Status} from 'commonTypes'
import {DatabaseMetadata, Query} from 'graphql-api'

const defaultTotalsState = {
  showFilters: false,
  hydrate: false,
  gridSession: {
    filters: {
      jobStatus: [] as JobStatusType[],
      databaseId: [] as string[],
    },
    filterOptions: {
      raveUrl: [] as DatabaseMetadata[],
    },
  },
  status: Status.IDLE,
  error: null,
  tabs: {
    [TabType.databases]: 0,
    [TabType.jobs]: 0,
  },
  homeStats: {} as Query,
}

export type GridSessionType = typeof defaultTotalsState.gridSession

export type FiltersType = typeof defaultTotalsState.gridSession.filters

export type TotalsStateType = typeof defaultTotalsState

export default defaultTotalsState
